import { TranslationKeys } from "./TranslationKey";

export const it: TranslationKeys = {
  "application.examLocationAndDate.chkeckingAvailabilityOfExams": "Verifica della disponibilità degli esami. Attendi...",
  "application.examLocationAndDate.dateColumn": "Date",
  "application.examLocationAndDate.examColumn": "Esame",
  "application.examLocationAndDate.examFull": "Purtroppo, tutti i posti sono già prenotati. Ti consigliamo di registrarti nella lista d'attesa.",
  "application.examLocationAndDate.examTypeColumn": "Tipo di esame",
  "application.examLocationAndDate.languageColumn": "Lingua",
  "application.examLocationAndDate.locationColumn": "Luogo",
  "application.examLocationAndDate.moduleColumn": "Modulo",
  "application.examLocationAndDate.statusColumn": "Stato",
  "application.examLocationAndDate.validattion.examsHaveDifferentLocations": "Non è possibile prenotare esami in luoghi diversi nello stesso giorno. Si prega di regolare la selezione.",
  "application.examLocationAndDateExplanationText": "Si prega di selezionare luogo e data per gli esami selezionati.",
  "application.moduleSelector.examsColumn": "Esami",
  "application.moduleSelector.noAvaiableModules": "Nessun modulo disponibile",
  "application.moduleSelector.typeColumn": "Tipo",
  "application.selectedExamsTitle": "Moduli ed esami selezionati",
  "application.uploadVerificationFilesMessage": "Se possiede un file addizionale lo carichi adesso",
  "application.userSelector.course": "Corso",
  "application.userSelector.examSession": "Sessione d'esame",
  "application.userSelector.noSelectedModules": "Nessun modulo selezionato",
  "cancellationTaskForm.candidateSubHeader": "candidato",
  "cancellationTaskForm.certificationTypeLabel": "tipo di certificazione",
  "cancellationTaskForm.commentsLabel": "commenti",
  "cancellationTaskForm.completeTask": "salvare e completare il compito",
  "cancellationTaskForm.createdOn": "creato su",
  "cancellationTaskForm.dateLabel": "data",
  "cancellationTaskForm.emailLabel": "email",
  "cancellationTaskForm.examTypeLabel": "tipo di esame",
  "cancellationTaskForm.firstNameLabel": "nome",
  "cancellationTaskForm.header": "Compito di cancellazione",
  "cancellationTaskForm.lastNameLabel": "Cognome",
  "cancellationTaskForm.locationLabel": "luogo",
  "cancellationTaskForm.moduleSubHeader": "Modulo",
  "cancellationTaskForm.navigateToCandidateSession": "Vai alla pagina della sessione del candidato",
  "cancellationTaskForm.roomLabel": "camera",
  "cancellationTaskForm.sessionLabel": "sessione",
  "cancellationTaskForm.timeSlotLabel": "fascia oraria",
  "candidate.button.exportAll": "esportare tutti i candidati",
  "candidate.button.new": "Aggiungi nuovo candidato",
  "candidate.button.uploadEdiIds": "caricare Ids EDI",
  "candidate.disableConfirmationDialog.message": "Assicuratevi che i vostri dettagli personali siano corretti, poiché non possono essere modificati in seguito.",
  "candidate.ediIdsDialog.title": "Selezionare il file che contiene gli Ids EDI",
  "candidate.ediIdsDialog.uploadSuccess": "Carica il successo. Numero di candidati aggiornati:",
  "candidate.field.canton": "Cantone",
  "candidate.field.correspondenceLanguage": "Lingua di corrispondenza",
  "candidate.field.invoiceRecipient": "Destinatario della fattura",
  "candidate.field.nationality": "Nazionalità",
  "candidate.field.numberOfFailedOralExams": "Esami orali non riusciti",
  "candidate.field.numberOfFailedWrittenExams": "Esami scritti non riusciti",
  "candidate.field.placeOfOrigin": "Luogo d'origine",
  "candidate.header": "Candidati",
  "candidate.section.invoice": "Fattura",
  "candidate.snackbar.successfulCreate": "Candidato è stato aggiunto.",
  "candidate.snackbar.successfulDelete": "Cadidato scelto è stato cancellato.",
  "candidate.snackbar.successfulExport": "Il numero di debitore dell'abaco è stato programmato per l'esportazione",
  "candidate.snackbar.successfulUpdate": "La modifiche sono state salvate.",
  "candidate.validation.disabledFields": "I campi non possono essere aggiornati dopo la conferma",
  "candidate.validation.idNotEmpty": "L'ID del candidato non può essere vuota.",
  "candidateAssignment.validation.preparationRoomNotAllowed.": "Un candidato non può essere assegnato a una stanza di preparazione.",
  "candidateCourse.certificate.fileNamePrefix": "Certificato",
  "candidateCourse.performanceRecord.fileNamePrefix": "Record di Prestazioni",
  "candidateCourseStatus.open": "Aperto",
  "candidateCourseStatus.passed": "Superato",
  "candidateWizard.error": "La registrazione per la certificazione non ha funzionato.",
  "candidateWizard.success": "Successo! Dovreste aver ricevuto un'e-mail per ogni prenotazione e i vostri esami appariranno nella vista Candidati.",
  "canton.ag": "Argovia",
  "canton.ai": "Appenzello Interno",
  "canton.ar": "Appenzello Esterno",
  "canton.be": "Berna",
  "canton.bl": "Basilea Campagna",
  "canton.bs": "Basilea Città",
  "canton.fr": "Friburgo",
  "canton.ge": "Ginevra",
  "canton.gl": "Glarona",
  "canton.gr": "Grigioni",
  "canton.ju": "Giura",
  "canton.lu": "Lucerna",
  "canton.ne": "Neuchâtel",
  "canton.nw": "Nidvaldo",
  "canton.ow": "Obvaldo",
  "canton.sg": "San Gallo",
  "canton.sh": "Sciaffusa",
  "canton.so": "Soletta",
  "canton.sz": "Svitto",
  "canton.tg": "Turgovia",
  "canton.ti": "Ticino",
  "canton.ur": "Uri",
  "canton.vd": "Vaud",
  "canton.vs": "Vallese",
  "canton.zg": "Zugo",
  "canton.zh": "Zurigo",
  "cart.validation.candidateIdNotEmpty": "L'ID del candidato deve essere fissato.",
  "cart.validation.cartEmpty": "Il carrello è vuoto.",
  "cart.validation.examAlreadyBooked": "Esame già prenotato.",
  "cart.validation.examNotFound": "Esame non trovato.",
  "cart.validation.missingCourseId": "ID corso mancante",
  "cart.validation.missingExamDayIdOnExam": "Manca l'ID del giorno dell'esame.",
  "cart.validation.missingExamSessionId": "ID sessione esame mancante",
  "cart.validation.missingInformationInModule": "Informazioni mancanti nel modulo.",
  "cart.validation.missingModuleId": "ID modulo mancante",
  "cart.validation.moduleAlreadyBooked": "Modulo già prenotato.",
  "cart.validation.moduleAlreadyPaid": "Modulo già pagato.",
  "cart.validation.moduleNotFound": "Modulo non trovato nel carrello.",
  "certification.button.new": "Registrazione All'esame",
  "certification.examDate": "Date di esame",
  "certification.examType": "Tipo d'esame",
  "certification.fachrichtung": "Opzione caso d'esame orale",
  "certification.state": "Stato",
  "certifications.noInfo": "Nessuna certificazione é disponibile",
  "common.accept": "Accettare",
  "common.archive": "Archiviare",
  "common.attention": "Attenzione",
  "common.build": "Costruire",
  "common.business": "Affare",
  "common.cancel": "Annulla",
  "common.certificationsGenerated": "Certificati generati",
  "common.close": "Ravvicinata",
  "common.comment": "Commento",
  "common.confirmArchiveDescription": "Vuoi davvero archiviare l'entità?",
  "common.confirmDeleteDescription": "Vuoi davvero cancellare l'entità?",
  "common.confirmPublishDescription": "Sei sicuro di voler pubblicare questa entità?",
  "common.copyToClipboard": "Copia negli appunti",
  "common.copyToClipboardDone": "Copiato negli appunti",
  "common.debtorNumber": "Numero del debitore",
  "common.delete": "Eliminare",
  "common.dragAndDrop.description": "Trascinare e rilasciare il documento qui",
  "common.errorMessage": "Qualcosa è andato storto",
  "common.exam": "Esame",
  "common.export": "Esportazione",
  "common.field.status": "Stato",
  "common.genders.female": "Femminile",
  "common.genders.male": "Maschio",
  "common.generateCertifications.confirmation": "Siete sicuri di voler generare delle certificazioni?",
  "common.generateCertifications": "Generare certificazioni",
  "common.info": "Informazioni",
  "common.language.de": "Tedesco",
  "common.language.en": "Inglese",
  "common.language.fr": "Francese",
  "common.language.it": "Italiano",
  "common.language": "Lingua",
  "common.languages": "Lingue",
  "common.lastModification.by": "da",
  "common.lastModification.on": "il",
  "common.lastModification": "Ultima modifica",
  "common.module": "Modulo",
  "common.no": "No",
  "common.noLanguagesAssigned": "Nessuna lingua assegnata",
  "common.ok": "Ok",
  "common.orderId": "ID ordine",
  "common.pleaseSelect": "Si prega di scegliere",
  "common.private": "Privato",
  "common.publish": "Pubblicare",
  "common.reject": "Rifiuto",
  "common.rejected": "Respinto",
  "common.roomLanguage": "Lingua della stanza",
  "common.roomType": "Tipo di stanza",
  "common.rowsPerPage": "Rows per page:",
  "common.save": "Salva",
  "common.scheduleCorrectionExams": "Pianificazione di correzione",
  "common.scheduleOralExams": "Prommagazione esami orali",
  "common.scheduleWrittenExams": "Programmare gli esami scritti",
  "common.search": "Ricerca",
  "common.selectElement": "Seleziona un",
  "common.selectElements": "Seleziona",
  "common.signOut": "Disdire",
  "common.status.archived": "Archiviato",
  "common.status.cancelled": "Annullato",
  "common.status.deleted": "Cancellato",
  "common.status.draft": "Bozza",
  "common.status.published": "Pubblicato",
  "common.survey": "sondaggio",
  "common.timeSlotStructure": "Struttura della fascia oraria",
  "common.total": "Totale",
  "common.transaction.failMessage.declined": "L'istituto di credito ha rifiutato il pagamento. Si prega di provare un altro metodo di pagamento.",
  "common.transaction.id": "ID della transazione",
  "common.unexpectedError": "Errore inatteso. Per favore, riprova più tardi.",
  "common.Unknown": "Sconosciuto",
  "common.unpublish": "Non pubblicare ",
  "common.uploadError": "errore di caricamento. Il formato del file non è valido.",
  "common.uploadSizeError": "Errore di caricamento. Il file supera la dimensione massima di {size} MB.",
  "common.validation.entityWithIdNotExistsAndCanNotBeAssigned": "L'entità con l'ID dato non è stata trovata e non può essere assegnata.",
  "common.validation.entityWithIdNotExistsAndCanNotBeDeleted": "L'entità con l'ID dato non è stata trovata e non può essere cancellata.",
  "common.validation.idNotEmpty": "L'ID non può essere vuoto.",
  "common.validation.name.empty": "Il nome non può essere vuoto.",
  "common.validation.status.empty": "Lo stato non può essere vuoto.",
  "common.validation.status.invalidTransition": "Questa transizione di stato non è valida.",
  "common.validation.status.invalidValue": "Il valore di stato non è corretto.",
  "common.yes": "Sì",
  "countries.switzerland.name": "Svizzera",
  "course.button.addModules": "Aggiungere i moduli",
  "course.dialog.confirmPublishDescription": "Sei sicuro di voler pubblicare questo corso?",
  "course.dialog.noAvailableModules": "Nessun modulo disponibile.",
  "course.dialog.selectModules": "Selezione di moduli",
  "course.field.certificateValidity.FiveYears": "5 anni",
  "course.field.certificateValidity.Unlimited": "Illimitato",
  "course.field.certificateValidity": "Validità della certificazione",
  "course.field.moduleRelevantForGrade": "Rilevante per il voto del corso",
  "course.field.modulesValidity.days": "giorni",
  "course.field.modulesValidity.unlimited": "Illimitata",
  "course.field.modulesValidity": "Validità dei moduli",
  "course.field.name": "Nome del corso",
  "course.field.nameDE": "Nome del corso - DE",
  "course.field.nameEN": "Nome del corso - EN",
  "course.field.nameFR": "Nome del corso - FR",
  "course.field.nameIT": "Nome del corso - IT",
  "course.field.numberOfMandatoryModules": "Numero di moduli obbligatori",
  "course.field.numberOfProcessModules": "Numero di moduli di processo",
  "course.field.numberOfSelectionModules": "Numero di moduli di selezione",
  "course.header": "Corso",
  "course.list.header": "Corsi",
  "course.section.modules": "Moduli",
  "course.snackbar.successfulArchive": "Il corso è stato archiviato con successo.",
  "course.snackbar.successfulDelete": "Il corso è stato cancellato con successo.",
  "course.snackbar.successfulPublish": "Il corso è stato pubblicato con successo.",
  "course.type.cicero": "Attestato professionale federale/Cicero",
  "course.type.ciceroGroup": "Gruppo Attestato professionale federale/Cicero",
  "course.type.hve": "FPS",
  "course.type.hveGroup": "Gruppo FPS",
  "course.type.intermediary": "Intermediario",
  "course.type.intermediaryGroup": "Gruppo Intermedidario",
  "course.type.mindeststandard": "Standard minimi",
  "course.type.mindeststandardGroup": "Gruppo standard minimi",
  "course.type": "Tipo di corso",
  "course.validation.idNotEmpty": "L'ID del corso non può essere vuoto.",
  "course.validation.modules.empty": "Si prega di selezionare almeno un modulo.",
  "course.validation.numberOfAnyModulesIsZero": "Il numero totale di moduli deve essere almeno 1.",
  "course.validation.typeIsInvalid": "Il tipo di corso non è valido.",
  "course.validation.typeNotEmpty": "Seleziona il tipo di corso",
  "courseManagement.header": "Corsi",
  "dragAndDrop.uploadFiles": "Caricare i file introducendoli quì",
  "exam.button.new": "Aggiungere un nuovo esame",
  "exam.field.correctionExpenses": "Spese di correzione",
  "exam.field.courseType": "Tipo di corso",
  "exam.field.examExpenses": "Spese d'esame",
  "exam.field.examId": "ID esame",
  "exam.field.examName": "Nome dell'esame ",
  "exam.field.examNameDE": "Nome dell'esame DE",
  "exam.field.examNameEN": "Nome dell'esame EN",
  "exam.field.examNameFR": "Nome dell'esame FR",
  "exam.field.examNameIT": "Nome dell'esame IT",
  "exam.field.expertExpenses": "Spese di esperti",
  "exam.field.type": "Tipo di esame",
  "exam.header": "Esami",
  "exam.section.specifics": "Specifiche dell'esame",
  "exam.snackbar.successfulArchive": "Esame scelto è stato archiviato.",
  "exam.snackbar.successfulDelete": "Esame scelto è stato cancellato.",
  "exam.snackbar.successfulPublish": "Esame scelto è stato pubblicato.",
  "exam.type.oral": "Esame orale",
  "exam.type.termPaper": "Carta a termine",
  "exam.type.written": "Esame scritto",
  "exam.validation.idNotEmpty": "Il nome dell'esame non deve essere vuoto",
  "examApplication.field.candidates": "Candidati",
  "examApplication.field.case": "Caso",
  "examApplication.validation.timeslotIsOverbooked": "Almeno un esame è in overbooking. Questo può accadere se si aggiungono nuove applicazioni mentre si apportano modifiche nella vista di pianificazione.",
  "examAssignment.validation.preparationRoomNotAllowed": "Errore durante il recupero della configurazione.",
  "examDay.button.assignExpertsToCorrectionExams": "Assegnare l'esperto di correzione",
  "examDay.button.assignExpertsToOralExams": "Assegni esperti al esame orale",
  "examDay.button.assignProctorsToOralPreparations": "Assegni esperti di sorveglianza per la preparazione esami orali",
  "examDay.button.assignProctorsToWrittenExams": "Assegni esperti di sorveglianza per la preparazione esami scritti ",
  "examDay.button.new": "Aggiungi nuovo giorno d'esame",
  "examDay.field.date": "Data",
  "examDay.field.header": "Giorno dell'esame",
  "examDay.field.numberOfRoomsAssigned": "Sale sono state assegnate",
  "examDay.field.preparationRoom": "Sala di preparazione",
  "examDay.field.timeSlotStructure.correction": "Correzione",
  "examDay.field.timeSlotStructure.electiveWritten": "Voto per iscritto",
  "examDay.field.timeSlotStructure.mandatoryWritten": "Obbligatorio per iscritto",
  "examDay.field.timeSlotStructure.oralHBB_ProcessModule": "Orale HBB modulo del processo",
  "examDay.field.timeSlotStructure.oralIntermediary": "Orale mediatore",
  "examDay.field.timeSlotStructure.oralLife": "Parte dell'esame della vita",
  "examDay.field.timeSlotStructure.placeholder": "Fasce orarie",
  "examDay.field.timeSlotStructure.writtenHBB_ProcessModule": "Scritto HBB modulo del processo",
  "examDay.field.timeSlotStructure.writtenIntermediary": "Scritto mediatore",
  "examDay.field.timeSlotStructure": "Fasce orarie",
  "examDay.field.type.correction": "Correzione",
  "examDay.field.type.oral": "Orale",
  "examDay.field.type.written": "Scritto",
  "examDay.field.type": "Tipo",
  "examDay.validation.alreadyExistsForLocationOnSameDate": "Esiste già un altro giorno d'esame con la stessa data e lo stesso luogo.",
  "examDay.validation.examTypeUnknown": "Il tipo di esame è sconosciuto. Scegliere un tipo di esame esistente.",
  "examDay.validation.idNotEmpty": "L'ID del giorno d'esame non puo' essere vuoto.",
  "examDay.validation.notFound": "Giorno d'esame non trovato.",
  "examDay.validation.onlyOnePreparationRoomAllowed": "Solo una sala di preparazione può essere aggiunta al giorno.",
  "examDay.validation.roomCanNotBeAssignedToSelectedExamType": "La sala non può essere assegnata perché non è applicabile al tipo di esame di questa giornata d'esame.",
  "examDay.validation.selectedRoomAlreadyAssigned": "La sala è già stata assegnata.",
  "examDay.validation.selectedRoomIsPcRoomAndCanNotBeUsed": "La sala è una sala informatica e non può essere assegnata.",
  "examManagement.header": "Esami",
  "examScore.grade": "Grado",
  "examScore.points": "Punti",
  "examSession.alert.builderInformation": "Per favore, assicurati di aver selezionato almeno un giorno d'esame e almeno una posizione prima di salvare la sessione d'esame.",
  "examSession.button.calculateExamResults": "Calcolo dei risultati degli esami",
  "examSession.button.exportCandidates": "Esportare i candidati per fascia oraria e/o tipo di esame",
  "examSession.button.exportOrders": "Esportazione degli ordini mancanti XML",
  "examSession.button.importExamScoresAndGrades": "Importazione di punti e punteggi",
  "examSession.button.importPev": "Importare il PEV",
  "examSession.button.new": "Aggiungere una nuova sessione d'esame",
  "examSession.button.newBuilder": "Aggiungi tramite builder",
  "examSession.button.newLife": "Aggiungere una nuova sessione d'esame di vita",
  "examSession.button.publishExamResults": "Pubblicare i risultati degli esami",
  "examSession.candidateExportDialog.examDay.label": "Data",
  "examSession.candidateExportDialog.examDay.placeholder": "Seleziona una data",
  "examSession.candidateExportDialog.timeSlot.label": "Fascia oraria",
  "examSession.candidateExportDialog.timeSlot.placeholder": "Selezionare una fascia oraria",
  "examSession.candidateExportDialog.title": "Selezionare un tipo di esame e, opzionalmente, una fascia oraria",
  "examSession.confirmPublishResultsDialog.text": "È sicuro di voler pubblicare i risultati degli esami di questa sessione?",
  "examSession.dialog.noAvailableCourses": "Questo esame non è assegnato a nessun corso.",
  "examSession.dialog.selectCourseTypes": "Selezionare i tipi di corso",
  "examSession.field.candidatePin": "PIN del candidato",
  "examSession.field.correctionPeriod": "Periodo di correzione",
  "examSession.field.date": "Data",
  "examSession.field.examResultDate": "Tempo Risultato del test",
  "examSession.field.examSession": "Periodo d'esame",
  "examSession.field.examSessionDate": "Data della sessione d'esame",
  "examSession.field.expertPin": "PIN dell'esperto",
  "examSession.field.freeCancellationEndDate": "Cancellazione gratuita fino a quando",
  "examSession.field.from": "Dal",
  "examSession.field.gradingConferenceDate": "Data della conferenza di classificazione",
  "examSession.field.hidePastSessions": "Nascondere le sessioni precedenti",
  "examSession.field.inspectionPeriod": "Ispezione",
  "examSession.field.inspectionSignupEndDate": "Data di fine ispezione",
  "examSession.field.isLife": "Esame di vita",
  "examSession.field.lifeSessionsOnly": "Solo sessioni life",
  "examSession.field.published": "Pubblicato",
  "examSession.field.sessionKey": "Chiave di sessione",
  "examSession.field.sessionKeyDE": "Sessione d'esame DE",
  "examSession.field.sessionKeyEN": "Sessione d'esame EN",
  "examSession.field.sessionKeyFR": "Sessione d'esame FR",
  "examSession.field.sessionKeyIT": "Sessione d'esame IT",
  "examSession.field.signup": "Iscrizione",
  "examSession.field.signupDate": "Data di iscrizione",
  "examSession.field.signupEndDate": "Data finale di iscrizione",
  "examSession.field.signupStartDate": "Data di inizio iscrizione",
  "examSession.field.surveyDeadline": "termine limite rilevamento",
  "examSession.field.to": "Al",
  "examSession.header": "Sessioni d'esame",
  "examSession.importPevDialog.title": "Caricare il file contenente i dati PEV",
  "examSession.invitation.allLocations": "Tutti i luoghi",
  "examSession.invitation.flagged": "è già stata inviata un'e-mail per questa luogo",
  "examSession.invitation.selectLocations": "seleziona i luoghi",
  "examSession.invitation.snackbar.candidates": "Inviti inviati a {count} candidati.",
  "examSession.invitation.snackbar.experts": "Inviti inviati a {count} esperti.",
  "examSession.invitation": "Invitare esperti/candidati",
  "examSession.label.examSessionBuilder": "Costruttore di sessioni d'esame",
  "examSession.label.revealCandidatePin": "Mostra il PIN del candidato",
  "examSession.label.revealExpertPin": "Mostra il PIN dell'esperto",
  "examSession.mail.invitation": "invia invito",
  "examSession.mail.notifyCandidates": "informare i candidati",
  "examSession.mail.survey": "iniziare il sondaggio",
  "examSession.result.examSessionCreated": "La sessione d'esame è stata creata con successo.",
  "examSession.result.NotGenerated": "I risultati degli esami non sono ancora stati generati.",
  "examSession.select.assignNewLocation": "Assegnare una nuova posizione",
  "examSession.validation.atLeastOneLanguageIsSelectedForEachRoom": "È necessario selezionare almeno una lingua per ogni stanza.",
  "examSession.validation.betweenFromAndTo": "L'orario di iscrizione deve essere compreso tra le date dal a al",
  "examSession.validation.canNotBeDeletedBecauseLocationsInside": "La sessione d'esame non può essere cancellata perché ha assegnato una o più sedi.",
  "examSession.validation.canNotBeUnpublishedBecauseExistingApplication": "Sessione esame non può essere cancellata dato che esistono già delle iscrizioni.",
  "examSession.validation.canNotReapplyForDifferentLanguage": "Non è possibile ripresentare la domanda per la stessa sessione d'esame con una lingua diversa.",
  "examSession.validation.correctionEndDateLaterThanCorrectionStartDate": "La data finale della correzione deve essere successiva alla data di inizio della correzione. ",
  "examSession.validation.examsEndDateLaterThanExamsStartDate": "La data di fine degli esami deve essere successiva alla data di inizio degli esami. ",
  "examSession.validation.examSessionFull": "L'esame selezionato in questa sessione d'esame è purtroppo al completo. Si prega di selezionare un altro modulo o un'altra sessione d'esame.",
  "examSession.validation.examsNoCourseTypes": "Ad alcuni esami scritti o orali non è stato assegnato alcun tipo di corso. Si prega di assegnare almeno un tipo di corso.",
  "examSession.validation.examWithNotAllowedCourseTypes": "Ad alcuni esami non sono stati assegnati tipi di corso validi. Assicurarsi che tutte le assegnazioni siano corrette o ricaricare la pagina.",
  "examSession.validation.freeCancellationNotPossible": "La cancellazione gratuita non è più disponibile.",
  "examSession.validation.idNotEmpty": "L'ID sessione d'esame non può essere vuoto.",
  "examSession.validation.inspectionEndDateLaterThanInspectionStartDate": "La data di fine dell'ispezione deve essere successiva alla data di inizio dell'ispezione.",
  "examSession.validation.locationAlreadyExists": "La sede esiste già nella sessione d'esame.",
  "examSession.validation.locationDoesNotExist": "La sede non è stata trovata.",
  "examSession.validation.nameIsRequiredInAllLanguages": "Il nome della sessione d'esame è richiesto in tutte le lingue.",
  "examSession.validation.noExamFoundToSignup": "Non è stato trovato alcun esame per l'iscrizione.",
  "examSession.validation.notPublishedNoSurveyPossible": "Il rilevamento può essere inizilizzato solamente se la sessione d'esame é stata pubblicata.",
  "examSession.validation.notPublishedResultsPublishingNotPossible": "La pubblicazione dei risultati degli esami non è possibile perché la sessione d'esame non viene pubblicata.",
  "examSession.validation.publishedNoUpdatePossible": "La sessione d'esame viene pubblicata e non può essere aggiornata.",
  "examSession.validation.signupEndDateLaterThanSignupStartDate": "La data finale di iscrizione deve essere successiva alla data di inizio iscrizione.",
  "examSession.validation.signupStartDateLaterThanOrEqualFrom": "La data di inizio delle iscrizioni deve essere uguale o successiva alla data di Da.",
  "examSession.validation.someErrorsOccurred": "Alcuni moduli hanno errori",
  "examSession.validation.toLaterThanFrom": "La data di fine dell'esame deve essere successiva alla data di inizio dell'esame.",
  "examSession.validation.toLaterThanSignupEndDate": "La data di fine dell'esame deve essere successiva alla data di fine dell'iscrizione.",
  "examSession.validation.toLaterThanSignupStartDate": "La data di fine dell'esame deve essere successiva alla data di inizio dell'iscrizione.",
  "examSession.validation.withSameNameAlreadyExists": "Esiste già un'altra sessione d'esame con lo stesso nome.",
  "examSession.writtenExamScoresImportDialog.title": "Caricare il file che contiene i punteggi degli Esami scritti",
  "examSession.writtenExamScoresImportDialog.uploadSuccess": "Carica il successo. Numero di punteggi aggiornati:",
  "examSessionCandidate.addCandidate": "Aggiungi un candidato",
  "examSessionCandidate.addDialog.bookingWithInvoice": "Prenotazione con fattura",
  "examSessionCandidate.addDialog.candidate": "Candidato",
  "examSessionCandidate.addDialog.course": "Corso",
  "examSessionCandidate.addDialog.module": "Modulo",
  "examSessionCandidate.addDialog.rebookWithInvoice": "Rebook con fattura",
  "examSessionCandidate.addDialog.title": "Seleziona il candidato, il corso e il modulo",
  "examSessionCandidate.attachments": "Allegati",
  "examSessionCandidate.averageGrade": "Punteggio medio",
  "examSessionCandidate.book": "Prenotare",
  "examSessionCandidate.bookedBy": "Persona che ha effetuato la prenotazione",
  "examSessionCandidate.booking.error": "La sua selezione non è più disponibile. Si prega di riprovare.",
  "examSessionCandidate.bookingAvailableWhenRebooked": "La selezione dell'esame sarà disponibile quando il modulo verrà riprenotato.",
  "examSessionCandidate.bookingDialog.selectDate": "Selezionare una data",
  "examSessionCandidate.bookingDialog.selectLanguage": "Selezionare una lingua",
  "examSessionCandidate.bookingDialog.selectLocation": "Selezionare un luogo",
  "examSessionCandidate.bookingDialog.title": "Luogo e Date di esame",
  "examSessionCandidate.bookingTimestamp": "Tempo di prenotazione",
  "examSessionCandidate.cancel": "Annulla",
  "examSessionCandidate.cancellationTimestamp": "Tempo di annullamento",
  "examSessionCandidate.cancelledBy": "Persona che ha effetuato l'anunullamento",
  "examSessionCandidate.cancelModuleMessage": "Siete sicuri di voler cancellare questo modulo?",
  "examSessionCandidate.cancelModuleRefundInformation": "Se si rientra nel periodo di cancellazione gratuita, il modulo verrà rimborsato, altrimenti verrà creata un'attività di cancellazione.",
  "examSessionCandidate.certification": "Certificazione",
  "examSessionCandidate.exam": "Esame",
  "examSessionCandidate.examDate": "Date di esame",
  "examSessionCandidate.examType": "Tipo d'esame",
  "examSessionCandidate.isRepeater": "Ripetitore",
  "examSessionCandidate.locationAndDateEdit": "Modifica il luogo e la data dell'esame",
  "examSessionCandidate.module": "Modulo",
  "examSessionCandidate.option": "Opzione",
  "examSessionCandidate.orderDetails": "Dettagli dell'ordine",
  "examSessionCandidate.paymentState": "Stato del pagamento",
  "examSessionCandidate.publishResultsToEmployer": "Passare il risultato dell'esame",
  "examSessionCandidate.rebook": "Re-Prenota",
  "examSessionCandidate.resetManualState": "Imposta automaticamente lo stato",
  "examSessionCandidate.selectExamToRebook": "Seleziona un esame da riprenotare",
  "examSessionCandidate.setManualState": "Imposta lo stato manualmente",
  "examSessionCandidate.state": "Stato",
  "examSessionCandidate.validation.examAlreadyBookedForAnotherModule": "L'esame è già prenotato per un altro modulo.",
  "examSessionCandidate.validation.examNotFound": "L'esame non è stato trovato.",
  "examSessionCandidate.validation.idNotEmpty": "L'Exam SessionCandidateID non deve essere vuoto.",
  "examSessionCandidate.validation.invalidGrade": "Il grado non è valido.",
  "examSessionCandidate.validation.invalidScore": "Il punteggio non è valido",
  "examSessionCandidate.verificationRequired": "Verifica richiesta",
  "examSessionCandidateExamState.booked": "Prenotato",
  "examSessionCandidateExamState.cancelled": "Cancellato",
  "examSessionCandidateExamState.equivalence": "Equivalenza",
  "examSessionCandidateExamState.failed": "Esame non riuscito",
  "examSessionCandidateExamState.passed": "Esame superato",
  "examSessionCandidateModuleState.applicationAccepted": "Richiesta accettata",
  "examSessionCandidateModuleState.cancelled": "Cancellato",
  "examSessionCandidateModuleState.Cancelled": "Modulo annullato. È stata creata un'attività di sistema",
  "examSessionCandidateModuleState.equivalence": "Equivalenza",
  "examSessionCandidateModuleState.expired": "Scaduto",
  "examSessionCandidateModuleState.failed": "Modulo non riuscito",
  "examSessionCandidateModuleState.passed": "Modulo superato",
  "examSessionCandidateModuleState.Refunded": "Modulo rimborsato",
  "examSessionCandidateModuleState.verificationRequired": "Verifica richiesta",
  "examSessions.noInfo": "Non sono state trovate sessioni d'esame",
  "examState.booked": "prenotato",
  "examState.cancelled": "cancellato",
  "examState.none": "---",
  "expert.button.new": "Aggiuncere esperti",
  "expert.field.courseType.placeholder": "Selezionare i tipi di corso per il ruolo",
  "expert.field.exam.placeholder": "Selezionare gli esami per il ruolo",
  "expert.field.exam": "Examen IT",
  "expert.field.languages": "Lingue",
  "expert.field.role.add": "Aggiungere un nuovo ruoli",
  "expert.field.role.Aufsichtsexperten": "Esperti di sorveglianza ",
  "expert.field.role.delete": "Eliminare il ruoli",
  "expert.field.role.EinspracheKomission": "Commissione ricorsi",
  "expert.field.role.Expertenschulung": "Training per esperti",
  "expert.field.role.Hauptexperten": "Esperti chiave",
  "expert.field.role.Leiterprüfungszentrum": "Direttori centro d'esami Center",
  "expert.field.role.placeholder": "Selezionare nuovi ruoli per esperti",
  "expert.field.role.Prüfungsexperten": "Esaminatori",
  "expert.field.role.Prüfungskomission": "Commissione d'esami",
  "expert.field.role.QSK": "Commissione per la garanzia della qualità",
  "expert.field.role": "Ruoli",
  "expert.header": "Esperti",
  "expert.snackbar.successfulCreate": "Esperto é stato aggiunto.",
  "expert.snackbar.successfulDelete": "L'esperto selezionato é stato cancellato.",
  "expert.snackbar.successfulUpdate": "Le modifiche sono state salvate.",
  "expert.validation.idNotEmpty": "L'ID del esperto non può essere vuota.",
  "expertAssignment.validation.examNotAssignedToRoom": "Esami senza assegnazione di stanze",
  "expertAssignment.validation.expertAssignedToMultipleRoomsOnSameDay": "L'esperto viene assegnato a diverse stanze nello stesso giorno.",
  "expertAssignment.validation.expertNotRequiredRole": "L'esperto non ha il ruolo richiesto.",
  "expertAssignment.validation.expertNotSpeakingAnySupportedLanguage": "L'esperto non parla nessuna delle lingue richieste.",
  "expertAssignment.validation.roomNotAssignedToExamDay": "La sala non è assegnata al giorno dell'esame.",
  "expertAvailability.header": "Disponibilità",
  "expertAvailability.noDatesAvailable": "Al momento non ci sono date disponibilità",
  "expertAvailability.surveyDeadlinePassed": "Il termine per l'inserimento della disponibilità è scaduto",
  "expertCorrectionAvailability.header": "Disponibilità per la correzione dell'esame",
  "file.name": "nome del file",
  "home.candidate": "Vista del candidato",
  "home.expert": "Il punto di vista dell'esperto",
  "home.header": "Pagina iniziale",
  "home.me.edit": "Gestire il conto",
  "home.me": "Io e le mie impostazioni",
  "home.myAlertFields.link": "Si prega di gestire il proprio account.",
  "home.myAlertFields": "Sono richieste alcune informazioni obbligatorie.",
  "home.myCertifications": "I miei certificati",
  "home.myCourses.downloadCertificate": "Certificato",
  "home.myCourses.downloadPerformanceRecord": "Record di prestazioni",
  "home.myCourses.table.ClosingDate": "Data di chiusura",
  "home.myCourses.table.downloads": "Downloads",
  "home.myCourses": "I miei corsi",
  "home.myExamCases": "I miei casi d'esame",
  "home.myExamResults": "I risultati del mio esame",
  "home.myExams.newApplication": "Registrazione All'esame",
  "home.myExams.noExams": "Nessuna exame disponibile",
  "home.myExams.table.actionsColumn": "Azioni",
  "home.myExams.table.dateColumn": "Data",
  "home.myExams.table.examColumn": "Esame",
  "home.myExams.table.examTypeColumn": "Tipo di esame",
  "home.myExams.table.gradeColumn": "Grado",
  "home.myExams.table.locationColumn": "Luogo",
  "home.myExams.table.moduleColumn": "Modulo",
  "home.myExams.table.roomColumn": "Sala",
  "home.myExams.table.statusColumn": "Stato",
  "home.myExams.table.timeColumn": "Ora",
  "home.myExams": "I Miei Esami",
  "home.myExamSessions": "Le mie sessioni d'esame",
  "home.myFiles": "I miei file",
  "home.myTasks": "I miei compiti",
  "home.pendingItemsInCartMessage": "I moduli non sono ancora stati pagati. Volete continuare la prenotazione ora? Si prega di notare che il posto in un modulo non è riservato finché non è stato effettuato il pagamento.",
  "home.switch.candidate": "Passa alla visualizzazione candidato",
  "home.switch.expert": "Passa alla visualizzazione esperto",
  "icon.state.completed": "Completato",
  "icon.state.error": "Errore",
  "icon.state.fullyBooked": "Completato",
  "icon.state.incomplete": "Incompleto",
  "icon.state.paid": "Pagato",
  "import.pev.bookingFailed": "Non è possibile prenotare tutti i candidati.",
  "import.pev.failedImportCandidates": "Impossibile importare i candidati.",
  "import.pev.failedImportScoresAndGrades": "Impossibile importare i punteggi e i voti.",
  "import.pev.invalidCsv": "File CSV non valido.",
  "import.pev.missingEntities": "Alcune entità non sono state trovate. ID dei candidati: {candidateIds}. ID delle sessioni d'esame: {examSessionsIds}. ID dei corsi: {courseIds}. ID dei moduli: {moduleIds}. ID esami: {examIds}.",
  "import.pev.noExam": "Impossibile trovare l'esame. ID esame: {examId}.",
  "import.pev.noExamDayForExam": "Impossibile trovare un giorno d'esame disponibile per l'esame. ID sessione d'esame: {examSessionId}. ID esame: {examId}. Lingua: {language}.",
  "import.pev.success": "I dati PEV sono stati importati con successo.",
  "import.pev.wrongCourseModules": "I moduli non sono collegati al corso. ID corso: {courseId}. ID moduli: {moduleIds}.",
  "import.pev.wrongExamSessionExams": "Gli esami non sono collegati alla sessione d'esame. ID sessione d'esame: {examSessionId}. ID esami: {examIds}.",
  "import.pev.wrongModuleExams": "Gli esami non sono collegati al modulo. ID modulo: {moduleId}. ID esami: {examIds}.",
  "lifeExams.back": "Indietro",
  "lifeExams.book": "Prenotare",
  "lifeExams.confirm": "Conferma",
  "lifeExams.label.displayFullyBooked": "Mostrare anche le sessioni completamente prenotate",
  "lifeExams.label.register": "Selezionare",
  "lifeExams.label.sesionFullyBooked": "Nessun posto disponibile",
  "lifeExams.messages.courseNotFound": "Il corso non è stato trovato.",
  "lifeExams.messages.infoAlertAddUpdateOrConfirmPersonalData": "Si prega di inserire, aggiornare o confermare i propri dati personali prima di prenotare un esame.",
  "lifeExams.messages.infoAlertExams": "Vengono mostrati solo i posti d’esame disponibili in {lang}",
  "lifeExams.messages.infoAlertExamSessions": "Si vedono solo i mesi con posti d'esame liberi",
  "lifeExams.messages.noAvailableExams": "Nessun esame disponibile",
  "lifeExams.messages.warnAlertReservation": "Il posto non è garantito finché non viene effettuato il pagamento.",
  "lifeExams.pay": "Prenota + Paga",
  "lifeExams.paymentErrorInitializing": "Errore durante l'inizializzazione del pagamento",
  "lifeExams.redirectToMyVbv": "Reindirizzamento a MyVBV in {secondsLeft} secondi",
  "lifeExams.sessionAlreadyBooked": "Sessione d'esame già prenotata",
  "lifeExams.title": "Selezionare una data d'esame",
  "lifeExams.transactionCancelled": "La transazione {transactionId} è stata annullata",
  "lifeExams.transactionFailed": "Transazione {transactionId} non riuscita. Motivo: ",
  "lifeExams.transactionPaid": "Ora siete iscritti all'esame e riceverete a breve la conferma della vostra prenotazione via e-mail.",
  "lifeExams.waitingList": "Lista d'attesa",
  "location.button.new": "Aggiungere una nuova sede",
  "location.field.canton.placeholder": "Seleziona un Cantone",
  "location.field.canton": "Cantone",
  "location.field.city": "Città",
  "location.field.contactEmailAddress": "Email del contatto",
  "location.field.contactName": "Nome del contatto",
  "location.field.contactPhoneNo": "Telefono del contatto",
  "location.field.languageRegions": "Regioni linguistiche",
  "location.field.linkToMap": "Pianta del sito",
  "location.field.name": "Nome",
  "location.field.street": "Strada",
  "location.field.zipCode": "Codice postale",
  "location.header": "Sede",
  "location.validation.idNotEmpty": "L'ID sede non può essere vuoto.",
  "location.validation.languageUnknown": "La lingua è sconosciuta. Scegliere una lingua esistente.",
  "location.validation.nameAlreadyExists": "Esiste già un'altra sede con lo stesso nome.",
  "location": "luogo",
  "login.button.adminLogin": "Login VBV-Admin",
  "login.button.impressum": "Impressum",
  "login.button.impressumLink": "https://www.vbv.ch/it/impressum",
  "login.button.login": "Login",
  "login.error.errorLoadingAppRegistration": "Errore durante il recupero della registrazione dell'app",
  "login.text.external1": "Si iscriva per accedere alla sua applicazione.",
  "login.text.external2": "Si prega di utilizzare un browser moderno come Chrome o Edge. Questa piattaforma funziona esclusivamente con un notebook o un desktop. Non funziona con un tablet o un telefono cellulare.",
  "login.text.externalWarn": "Importante",
  "login.title.external": "Iscrizione come candidato/esperto",
  "module.button.new": "Aggiungi un nuovo modulo",
  "module.dialog.confirmPublishDescription": "Sei sicuro di voler pubblicare questo esame?",
  "module.dialog.noAvailableExams": "Nessun esame disponibile.",
  "module.dialog.noAvailableLocations": "Nessuna località disponibile.",
  "module.dialog.selectExams": "Selezione di esami",
  "module.dialog.selectLocations": "Selezionare le località",
  "module.field.abacusNumber": "Numero Abacus",
  "module.field.allowDocumentUpload": "Consentire il caricamento di documenti",
  "module.field.allowOptions": "Permettere le opzioni",
  "module.field.allowRegistrationOnlyOnce": "Disponibile una volta",
  "module.field.allRoomsAssigned": "Camera assegnata",
  "module.field.certificateValidity.FiveYears": "5 anni",
  "module.field.certificateValidity.OneYear": "1 anno",
  "module.field.certificateValidity.Unlimited": "Illimitato",
  "module.field.certificateValidity": "Validità della certificazione",
  "module.field.documentsUploaded": "Documenti caricati",
  "module.field.gradingRules.allExams": "Tutti gli esami devono essere superati",
  "module.field.gradingRules.averageGrade": "Punteggio medio",
  "module.field.gradingRules": "Regole di classificazione",
  "module.field.moduleId": "Modulo ID",
  "module.field.moduleName": "Nome del modulo",
  "module.field.moduleNameDE": "Nome del modulo DE",
  "module.field.moduleNameEN": "Nome del modulo EN",
  "module.field.moduleNameFR": "Nome del modulo FR",
  "module.field.moduleNameIT": "Nome del modulo IT",
  "module.field.moduleType.mandatory": "Obbligatorio",
  "module.field.moduleType.optionalModule": "Modulo elettivo",
  "module.field.moduleType.processModule": "Modulo di processo",
  "module.field.moduleType": "Tipo di modulo",
  "module.field.needsApproval": "Ha bisogno di approvazione",
  "module.field.paymentState": "Stato del pagamento",
  "module.field.price": "Prezzo in CHF",
  "module.field.verificationRequired": "Verifica richiesta",
  "module.header": "Moduli",
  "module.moduleDetails": "Dettagli del modulo",
  "module.section.specifics": "Specifiche del modulo ",
  "module.snackbar.successfulArchive": "Modulo scelto è stato archiviato.",
  "module.snackbar.successfulDelete": "Modulo scelto è stato cancellato.",
  "module.snackbar.successfulPublish": "Esame scelto è stato pubblicato.",
  "module.validation.gradingRule.invalidValue": "Il valore della regola di classificazione non è corretto.",
  "module.validation.idNotEmpty": "L'ID del modulo non può essere vuoto.",
  "module.validation.invalidStatusTransition": "Questa transizione di stato non è valida.",
  "module.validation.invalidStatusValue": "Il valore di stato non è corretto.",
  "module.validation.statusNotEmpty": "Lo stato non può essere vuoto.",
  "oralExamOption.kmu": "Piccole imprese",
  "oralExamOption.none": "Nessuna",
  "oralExamOption.privathaushalte": "Domestica privata",
  "paymentMethodSelector.form.button": "Pagare con fattura",
  "paymentMethodSelector.item.creditCard": "Carta di credito / Twint",
  "paymentMethodSelector.item.invoice": "Fattura",
  "paymentMethodSelector.item.invoiceMessage": "Indirizzo privato (CH)",
  "paymentMethodSelector.title": "Scegliere il metodo di pagamento",
  "paymentStatus.paid.abacus": "Fatturato (Abacus)",
  "paymentStatus.paid.ePayment.cembraPay": "Pagato (e-payment: CembraPay)",
  "paymentStatus.paid.ePayment.creditCard": "Pagato (e-payment: Carta di credito / Twint)",
  "paymentStatus.refunded.abacus": "Rimborsato (Abacus)",
  "paymentStatus.refunded.ePayment.cembraPay": "Rimborsato (e-payment: CembraPay)",
  "paymentStatus.refunded.ePayment.creditCard": "Rimborsato (e-payment: Carta di credito / Twint)",
  "person.field.activateSpecificProfile": "Attivare il profilo dell'esperto",
  "person.field.ahvNumber": "Numero AVS",
  "person.field.bankAccount": "Conto bancario",
  "person.field.birthDate": "Data di nascita",
  "person.field.ciceroNumber": "Numero Cicero",
  "person.field.city": "Luogo di residenza",
  "person.field.country": "Paese",
  "person.field.displayName": "Nome",
  "person.field.email": "Email",
  "person.field.employer": "Datore di lavoro",
  "person.field.employerCity": "Città del datore di lavoro",
  "person.field.employerCountry": "Seleziona Paese del datore di lavoro",
  "person.field.employerStreet": "Strada del datore di lavoro",
  "person.field.employerStreetNumber": "Numero di strada del datore di lavoro",
  "person.field.employerZipCode": "CAP del datore di lavoro",
  "person.field.firstName": "Nome",
  "person.field.gender.placeholder": "Selezionare un genere",
  "person.field.gender": "Genere",
  "person.field.homeCountry": "Paese nativo",
  "person.field.icon": "Simbolo dell'attore",
  "person.field.internalComment": "Commento interno",
  "person.field.lastName": "Cognome",
  "person.field.mobileNumber": "Numero di cellulare",
  "person.field.phoneNumber.placeholder": "Formato: +41123456789",
  "person.field.phoneNumber": "Numero di telefono",
  "person.field.showOnlyExperts": "Visualizzare solo gli esperti",
  "person.field.street": "Strada",
  "person.field.streetNumber": "Numero",
  "person.field.zipCode": "Codice postale del luogo di residenza",
  "person.section.address": "Indirizzo privato",
  "person.section.businessData": "Dati commerciali",
  "person.section.expertDetails": "Dettagli specifici dell'esperto",
  "person.section.personalDetails": "Dettagli personali",
  "person.validation.ahvNumberAlreadyExists": "Esiste già un altro utente con lo stesso numero AHV.",
  "person.validation.ahvNumberNotValid": "Il numero AVS non è valido.",
  "person.validation.bankAccountNotEmpty": "Il conto bancario non può essere vuoto",
  "person.validation.ciceroNumberAlreadyExists": "Esiste già un altro utente con lo stesso numero Cicero.",
  "person.validation.ciceroNumberNotValid": "Il numero Cicero non è valido.",
  "person.validation.confirmEmailChange": "L'indirizzo e-mail è stato modificato. Questo modificherà anche l'email di accesso. Sei sicuro di voler continuare?",
  "person.validation.emailAlreadyExists": "Esiste già un altro utente con la stessa email.",
  "person.validation.genderUnknown": "Il genere è sconosciuto. Si prega di scegliere un genere esistente.",
  "person.validation.invalidEmployerZipCode": "Il codice postale del datore di lavoro non è valido.",
  "person.validation.invalidZipCode": "Il codice postale del luogo di residenza non è valido.",
  "person.validation.mandatoryExamRolesWithNoExams": "Ci sono ruoli d'esame obbligatori che non hanno esami assegnati. Assegnare gli esami mancanti.",
  "person.validation.personEdiIdNotEmpty": "L'ID EDI non può essere vuoto",
  "person.validation.personEmailAddressNotEmpty": "L'indirizzo e-mail non può essere vuoto",
  "person.validation.repeatedRoles": "I ruoli si ripetono. Assicuratevi che non ci siano ruoli ripetuti.",
  "person.validation.typeUnknown": "Il tipo di persona è sconosciuto. Scegliere un tipo esistente.",
  "role.validation.roleUnknown": "Ruolo sconosciuto",
  "room.button.new": "Assegnazione nuova sala",
  "room.field.floor": "Pavimento",
  "room.field.isPcRoom": "Sala informatica",
  "room.field.name": "Nome",
  "room.field.numberOfSeats": "Capienza",
  "room.header": "Sala",
  "room.text.seats": "posti",
  "room.validation.idNotEmpty": "L'ID sala non può essere vuoto.",
  "room.validation.nameAlreadyExists": "Esiste già un'altra sala con lo stesso nome.",
  "roomAssignment.button.new": "Assegnare una stanza",
  "roomAssignment.deleteConfirmation.title": "Stai per rimuovere un'aula di preparazione. Si assicuri che ci sia una stanza di preparazione assegnata a questa data d'esame.",
  "roomAssignment.field.isPreparationRoom": "Sala di preparazione",
  "roomAssignment.field.room.placeholder": "Selezionare una camera",
  "roomAssignment.field.room": "Camera",
  "roomAssignment.header": "Assegnazione della stanza",
  "roomAssignment.validation.idNotEmpty": "L'assegnazione della stanza non può essere vuota",
  "scheduler.examSelectDialog.title": "Seleziona l'esame per la stanza",
  "scheduler.examSelectDialog.tooltip": "Imposta l'esame per tutte le fasce orarie",
  "scheduler.message.briefing": "Briefing per esperti",
  "scheduler.message.exam": "Esame",
  "scheduler.message.noExperts": "Nessun esperto assegnato",
  "scheduler.message.pause": "Pausa",
  "scheduler.timeSlot.arrivalTime": "Ora di arrivo",
  "selfcancellation.header": "Annullamento del modulo",
  "selfcancellation.text": "Attenzione: Si prega di confermare che si desidera annullare l'iscrizione all'esame.",
  "startCertification.button.back": "Indietro",
  "startCertification.button.finish": "Fine",
  "startCertification.button.next": "Prossimo",
  "startCertification.courseModuleExamsStep.header": "Scegliere il corso, il modulo e gli esami",
  "startCertification.examDataStep.header": "Selezionare tipo d'esame, luogo e data",
  "startCertification.examDataStep.selectCompany": "Selezionare datore di lavoro",
  "startCertification.examDataStep.selectExamSession": "Seleziona la sessione d'esame",
  "startCertification.examDataStep.selectFachrichtung": "Selezionare ramo tecnico",
  "startCertification.examDataStep.selectLocationOralPart": "Selezionare un luogo per la parte orale del suo esame",
  "startCertification.examDataStep.selectLocationWrittenPart": "Selezionare un luogo per la parte scritta del suo esame",
  "startCertification.examDataStep.selectOralExamDate": "Selezionare una data per l' esame orale",
  "startCertification.examDataStep.selectWrittenExamDate": "Selezionare una data per l'esamo scritto",
  "startCertification.locationDateStep.header": "Scegliere il luogo e la data dell'esame",
  "startCertification.modulesDetailsStep.dialogHelperText": "Si prega di completare le informazioni mancanti e di caricare i documenti richiesti, se necessario.",
  "startCertification.modulesDetailsStep.docsText1": "Si prega di caricare tutti i documenti richiesti per questo modulo.",
  "startCertification.modulesDetailsStep.docsText2": "Se non puoi caricare i documenti in questo momento, segnalo qui sotto. Ti assegneremo un compito appropriato.",
  "startCertification.modulesDetailsStep.fillDetails": "Dettagli completi",
  "startCertification.modulesDetailsStep.header": "Fornire informazioni e documenti",
  "startCertification.modulesDetailsStep.helperText": "Si prega di completare le informazioni mancanti e di caricare i documenti richiesti per i moduli selezionati.",
  "startCertification.modulesDetailsStep.isRepeater": "Sono ripetitore",
  "startCertification.modulesDetailsStep.option.kmu": "PMI",
  "startCertification.modulesDetailsStep.option.privathaushalte": "Privado",
  "startCertification.modulesDetailsStep.option": "Opzione",
  "startCertification.modulesDetailsStep.tableTitle": "Moduli selezionati",
  "startCertification.modulesDetailsStep.trainingProvider": "Fornitore di formazione",
  "startCertification.modulesDetailsStep.willUploadDocsLater": "Caricare i documenti più tardi",
  "startCertification.moduleSelectionStep.header": "Scegliere il corso, il modulo e gli esami",
  "startCertification.moduleSelectionStep.helperText": "Seleziona un corso e una sessione d'esame per selezionare i moduli e gli esami a cui vuoi iscriverti.",
  "startCertification.moduleSelectionStep.priceColumn": "Prezza in CHF",
  "startCertification.moduleSelectionStep.removeButton": "Rimuovi",
  "startCertification.moduleSelectionStep.selectButton": "Selezionare",
  "startCertification.moduleSelectionStep.selectedModules": "I tuoi moduli selezionati",
  "startCertification.paymentAndCompletionStep.actionColumn": "Azione",
  "startCertification.paymentAndCompletionStep.button.confirm": "Prenota ora in modo vincolante",
  "startCertification.paymentAndCompletionStep.button.confirmed": "Confermato",
  "startCertification.paymentAndCompletionStep.button.paid": "Pagato",
  "startCertification.paymentAndCompletionStep.button.pay": "Paga",
  "startCertification.paymentAndCompletionStep.freeCancelDate": "cancellazione gratuita fino a ",
  "startCertification.paymentAndCompletionStep.generalInfo.cost1": "Dopo tale termine, ",
  "startCertification.paymentAndCompletionStep.generalInfo.cost2bold": "in caso di cancellazione ingiustificata va corrisposta",
  "startCertification.paymentAndCompletionStep.generalInfo.cost3": " l'intera tassa d'esame.",
  "startCertification.paymentAndCompletionStep.generalInfo.freeCancellation": "L'iscrizione è vincolante. Potrà annullare l'iscrizione fino alle date indicate sopra senza costi aggiuntivi.",
  "startCertification.paymentAndCompletionStep.generalInfo.hveFAQLink": "https://www.vbv.ch/fileadmin/vbv/Dokumente/Bildungsabschluesse/Versicherungsfach/72047_PO_Versicherungsfachleute_I_2022.pdf",
  "startCertification.paymentAndCompletionStep.generalInfo.hveFAQLinkText": "FAQ attestato professionale federale",
  "startCertification.paymentAndCompletionStep.generalInfo.intermediaryFAQLink": "https://www.vbv.ch/fileadmin/vbv/Dokumente/Bildungsabschluesse/Versicherungsvermittlung/FAQ_Vermi_Pruefungen_it.pdf",
  "startCertification.paymentAndCompletionStep.generalInfo.intermediaryFAQLinkText": "FAQ intermediario assicurativo",
  "startCertification.paymentAndCompletionStep.generalInfo.moreInformation1": "Ulteriori informazioni sono riportate nella rubrica ",
  "startCertification.paymentAndCompletionStep.generalInfo.moreInformation2": ".",
  "startCertification.paymentAndCompletionStep.header": "Pagamento e finalizzazione",
  "startCertification.paymentAndCompletionStep.hint": "Si prega di notare che il tuo posto in un modulo non è riservato fino al pagamento.",
  "startCertification.paymentAndCompletionStep.messages.transactionCancelled": "Transazione {id} annullata",
  "startCertification.paymentAndCompletionStep.messages.transactionConfirmed": "La transazione {id} è stata confermata",
  "startCertification.paymentAndCompletionStep.messages.transactionFailed": "Transazione {id} non riuscita",
  "startCertification.paymentAndCompletionStep.messages.transactionPaid": "La transazione {id} è stata pagata",
  "startCertification.paymentAndCompletionStep.messages.wrongTransactionId": "ID transazione non valido {id}",
  "startCertification.paymentAndCompletionStep.moduleFullyBooked": "Completamente prenotato",
  "startCertification.paymentAndCompletionStep.paymentConfirmationMessagePart1": "Ciò può richiedere fino a un minuto. Questo messaggio verrà chiuso automaticamente quando il pagamento sarà stato confermato.",
  "startCertification.paymentAndCompletionStep.paymentConfirmationMessagePart2": "In caso contrario, si prega di contattare VBV con l'ID della transazione: {datatransTrxId}",
  "startCertification.paymentAndCompletionStep.paymentConfirmationTitle": "In attesa della conferma del pagamento, si prega di attendere",
  "startCertification.paymentAndCompletionStep.removeModule": "Rimuovere il modulo",
  "startCertification.paymentAndCompletionStep.removeModuleConfirmation": "Si desidera rimuovere il modulo?",
  "startCertification.paymentAndCompletionStep.summary": "Riassunto",
  "startCertification.personalDataStep.header": "Verificare la propria data",
  "startCertification.policyDialog.accept.link": "la politica sulla privacy/CGC",
  "startCertification.policyDialog.accept.linkUrl": "https://www.vbv.ch/it/dichiarazione-di-protezione-dei-dati",
  "startCertification.policyDialog.accept": "Accetto ",
  "startCertification.policyDialog.text1": "Con la presente dichiaro di riconoscere e accettare che al mio datore di lavoro vengano divulgate le informazioni seguenti: avvenuta iscrizione a una sessione d'esame, compresa la data della sessione d'esame, risultati dell'esame, compresi le note/i punti e la notifica del superamento o mancato superamento dell'esame, iscrizione nel registro Cicero ",
  "startCertification.policyDialog.text2": "Il presente consenso può essere revocato in qualsiasi momento e in forma libera mediante comunicazione scritta all'Associazione per la formazione professionale nell'assicurazione AFA o tramite e-mail da inviarsi all'indirizzo vermittler@vbv-afa.ch.",
  "startCertification.uploadFilesStep.header": "Caricare la verifica dei file",
  "table.noRecords": "Nessun record trovato",
  "task.creationDate": "Data di creazione",
  "task.deadline": "Termine ultimo",
  "task.noInfo": "Nessun compito pendente",
  "task.state": "Stato",
  "task.type": "Tipo",
  "task.validation.deadlineMustBeLaterThanToday": "Il termine ultimo dev'essere più tardi che oggi.",
  "task.validation.typeUnknown": "Tipo compito sconosciuto",
  "taskState.done": "Fatto",
  "taskState.inProgress": "In corso",
  "taskState.toDo": "Da fare",
  "taskType.cancellation": "Cancellazione",
  "taskType.checkAvailability": "Communicare disponibilità",
  "taskType.checkCorrectionAvailability": "Inserisci la disponibilità per la correzione dell'esame",
  "taskType.none": "Nessuna",
  "taskType.uploadDocuments": "Caricare i documenti",
  "uploadDocumentsTask.header": "Compito di caricamento dei documenti",
  "uploadDocumentsTask.instructions": "Carica tutti i documenti richiesti per questo modulo e completa il compito quando hai finito.",
  "user.noInfo": "Nessun informazione utente",
  "user.settings": "Impostazioni",
  "userRoomAssignment.assignment": "Assegnazioni",
  "userRoomAssignment.label.allExpertsSwitch": "Mostra tutti gli esperti",
  "userRoomAssignment.label.fixed": "fissati",
  "userRoomAssignment.label.fixedCorrectionExperts": "Esperti correzione fissati",
  "userRoomAssignment.label.fixedExperts": "Esperti fissati(2x)",
  "userRoomAssignment.label.fixedProctors": "Esperti di sorveglianza fissati(2x)",
  "userRoomAssignment.label.reserve": "Riserva",
  "userRoomAssignment.label.reserveCorrectionExperts": "Esperti correzione di reserva",
  "userRoomAssignment.label.reserveExperts": "Esperti riserva",
  "userRoomAssignment.label.reserveProctors": "Esperti di sorveglianza di riserva",
  "userRoomAssignment.label.roomFull": "La stanza è piena",
  "userRoomAssignment.label.roomOverload": "La stanza è sovraccarica",
  "userRoomAssignment.placeholder.selectFixedExperts": "Selezionare esperti fissi",
  "userRoomAssignment.placeholder.selectFixedProctors": "Selezionare esperti di sorveglianza",
  "userRoomAssignment.placeholder.selectReserveExperts": "Selezionare esperti di riserva",
  "userRoomAssignment.placeholder.selectReserveProctors": "Selezionare esperti di sorveglianza di riserva",
};
